import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input() userProfile: any;
  @Output() signOut = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  logOut() {
    this.signOut.emit();
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/header/header.component.ts